import React, { useEffect, useState } from 'react';
import { Auth, Hub } from 'aws-amplify';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import awsConfig from '../awsConfig';

const SAMLCallback = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { setUser } = useAuth();
    const [error, setError] = useState(null);

    useEffect(() => {

        const handleCallback = async () => {
    
            try {
    
                console.log('Starting SAML callback handling...');
     
                // Get URL parameters
    
                const searchParams = new URLSearchParams(location.search);
    
                const code = searchParams.get('code');
    
                const state = searchParams.get('state');
    
                const errorParam = searchParams.get('error');
     
                console.log('Auth parameters:', {
    
                    code: code ? 'Present' : 'Missing',
    
                    state,
    
                    error: errorParam,
    
                    fullUrl: window.location.href
    
                });
     
                // === Changes Start: Route to Error Page and clear cookies ===
                // Check for SAML error or missing success
                if (errorParam || !code) {
                    const errorMessage = errorParam
                        ? `Authentication error: ${errorParam}`
                        : 'SAML authentication did not return success code';
                    throw new Error(errorMessage);
                }
                // === Changes End ===
     
                // Continue only if SAML was successful
                const identityProvider = awsConfig.Auth.oauth.identityProvider;
                const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
     
                if (!user) {
                    throw new Error('No user found after authentication');
                }
     
                console.group('SAML Authentication Details');
    
                const attributes = user.attributes;
    
                console.table(attributes);
    
                console.groupEnd();
     
                setUser(user);
    
                navigate('/auth', { replace: true });
     
            } catch (error) {
    
                console.error('Authentication Error Details:', {
    
                    message: error?.message || 'Unknown error',
    
                    code: error?.code || 'No error code',
    
                    name: error?.name || 'No error name',
    
                    stack: error?.stack,
    
                    fullError: error
    
                });
     
                // === Changes Start: Route to Error Page and clear cookies ===
    
                // Changes to Route to Error Page and clear cookies
    
                document.cookie = ''; // Clear all cookies
    
                localStorage.clear();
    
                sessionStorage.clear();
     
                try {
    
                    await Auth.signOut({ global: true });
                    // Then redirect to PingFederate's SLO (logout) URL
                    window.location.href = 'https://your-pingfed-domain/idp/startSLO.ping?TargetResource=https://main.d1azwsoa7w3th3.amplifyapp.com/login';
    
                } catch (signOutError) {
    
                    console.error('Error during cleanup:', signOutError);
    
                }
     
                alert("Access not permitted.  Please see your Manager to request access.");
    
                navigate('/', { replace: true });
    
                // === Changes End ===
    
            }
    
        };
    
     
    // useEffect(() => {
    //     const handleCallback = async () => {
    //         try {
    //             console.log('Starting SAML callback handling...');

    //             // Get URL parameters
    //             const searchParams = new URLSearchParams(location.search);
    //             const code = searchParams.get('code');
    //             const state = searchParams.get('state');
    //             const errorParam = searchParams.get('error');

    //             console.log('Auth parameters:', {
    //                 code: code ? 'Present' : 'Missing',
    //                 state,
    //                 error: errorParam,
    //                 fullUrl: window.location.href
    //             });

    //             // Check for error parameter
    //             if (errorParam) {
    //                 throw new Error(`Authentication error: ${errorParam}`);
    //             }

    //             // If no code is present, initiate federation
    //             const identityProvider = awsConfig.Auth.oauth.identityProvider;
    //             console.log('Identity Provider:', identityProvider);
    //             if (!code) {
    //                 console.log('No auth code found, initiating federation...');
    //                 const response = await Auth.federatedSignIn({
    //                     customProvider: identityProvider,
    //                     customState: state || undefined
    //                 });
    //                 console.log('Federation response:', response);
    //                 return;
    //             }

    //             // Try to complete the authentication
    //             console.log('Attempting to get current authenticated user...');
    //             const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

    //             if (!user) {
    //                 throw new Error('No user found after authentication');
    //             }

    //             console.log('Authentication successful:', {
    //                 username: user.username,
    //                 attributes: user.attributes,
    //                 signInUserSession: user.signInUserSession ? 'Present' : 'Missing'
    //             });

    //             // Enhanced logging for SAML attributes
    //             console.group('SAML Authentication Details');
    //             console.log('User Basic Info:', {
    //                 username: user.username,
    //                 signInUserSession: user.signInUserSession ? 'Present' : 'Missing'
    //             });

    //             // Log all mapped attributes
    //             console.group('Mapped SAML Attributes');
    //             const attributes = user.attributes;
    //             console.log({

    //                 // User Attributes
    //                 'Email (Subject)': attributes.email,
    //                 'Given Name': attributes.given_name,
    //                 'Family Name': attributes.family_name,

    //                 // Groups
    //                 'Groups': attributes['custom:group_names'],
    //             });


    //             // Log all available attributes for debugging
    //             console.group('All Available Attributes');
    //             console.table(attributes);
    //             console.groupEnd();

    //             // Log token information
    //             console.group('Token Information');
    //             if (user.signInUserSession) {
    //                 const { idToken, accessToken } = user.signInUserSession;
    //                 console.log('ID Token Payload:', idToken.payload);
    //                 console.log('Access Token Payload:', accessToken.payload);
    //             }
    //             console.groupEnd();
    //             console.groupEnd();



    //             setUser(user);
    //             navigate('/auth', { replace: true });

    //         } catch (error) {
    //             console.error('Authentication Error Details:', {
    //                 message: error?.message || 'Unknown error',
    //                 code: error?.code || 'No error code',
    //                 name: error?.name || 'No error name',
    //                 stack: error?.stack,
    //                 fullError: error
    //             });
    //             // === Route to Error Page and clear cookies ===
    //             // Changes to Route to Error Page and clear cookies
    //             document.cookie = ''; // Clear all cookies
    //             localStorage.clear();
    //             sessionStorage.clear();
    //             // === Changes End ===
    //             // Set a user-friendly error message
    //             setError(
    //                 error?.message ||
    //                 'Unable to complete authentication. Please try again.'
    //             );

    //             // If federation failed, try to clear any partial auth state
    //             try {
    //                 await Auth.signOut();
    //             } catch (signOutError) {
    //                 console.error('Error during cleanup:', signOutError);
    //             }
    //             // Show user-facing popup
    //             alert("Error in Logging in");

    //             // Redirect to login page
    //             navigate('/', { replace: true });
    //             // === Changes End ===
            
    //     }
    // };

    // Set up Hub listener for auth events
    const hubListener = ({ payload: { event, data } }) => {
        console.log('Auth Hub Event:', event, data);

        switch (event) {
            case 'signIn':
                console.log('Sign in successful:', data);
                setUser(data);
                navigate('/auth', { replace: true });
                break;
            case 'signIn_failure':
                console.error('Sign in failed:', data);
                setError(data?.message || 'Sign in failed');
                break;
            case 'customOAuthState':
                console.log('Custom OAuth state:', data);
                break;
            default:
                console.log(`Unhandled auth event: ${event}`, data);
        }
    };

    Hub.listen('auth', hubListener);
    handleCallback();

    return () => Hub.remove('auth', hubListener);
}, [location, navigate, setUser]);

if (error) {
    return (
        <div className="error-container">
            <h2>Authentication Error</h2>
            <p>{error}</p>
            <button
                onClick={async () => {
                    try {
                        // Clear any existing auth state
                        await Auth.signOut({ global: true });
                        localStorage.clear();
                        sessionStorage.clear();
                        document.cookie = ''; // Clear all cookies
                        navigate('/', { replace: true });
                        window.location.href = 'https://your-pingfed-domain/idp/startSLO.ping?TargetResource=https://main.d1azwsoa7w3th3.amplifyapp.com/login';
                    } catch (error) {
                        console.error('Error during cleanup:', error);
                        // Force navigation even if cleanup fails
                        navigate('/', { replace: true });
                    }
                }}
                className="auth-button"
            >
                Try Again
            </button>
        </div>
    );
}

return (
    <div className="callback-container">
        <div className="loading-spinner"></div>
        <h2>Processing Authentication</h2>
        <p>Please wait while we complete your sign-in...</p>
    </div>
);
};

export default SAMLCallback;

